import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../consts/Constants.js";
import Style from "../../../../styles/js/StyleCallList.js";
import IconButton from '@mui/material/IconButton';
import DescriptionIcon from '@mui/icons-material/Description';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Tooltip from '@mui/material/Tooltip';
import CircularProgressWithLabel from "../../../../components/common/CircularProgressWithLabel.js";
import CircularProgress from '@mui/material/CircularProgress';

import service from '../../../../plas/services/calls/service';
import { createByteArray } from "../../../../plas/utils";
import alerter from '../../../alerts/alerter';

export default function Input( { application, inputData, contentData } ) {

  const style = Style();

  const [input] = React.useState(inputData);
  const [content, setContent] = React.useState(contentData);
  const [fileToDelete, setFileToDelete] = React.useState(null);
  const [progress, setProgress] = React.useState(null);

  const [downloadingA, setDownloadingA] = React.useState({}); // Descargas de auxiliary files
  const [downloadingB, setDownloadingB] = React.useState({}); // Descarga de archivos del usuario

  const inputFile = React.useRef(null) 

  const onButtonClick = () => {
    inputFile.current.click();
  }

  const onSelectFile = (event, input) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];

    uploadApplicationFile(input,file);
  }

  const onRemoveFile = (file) => {
    setFileToDelete(file.id);
    deleteApplicationFile(input, file);
  }

  const onUpdateProgress = (value) => {
    setProgress(value);
  }

  const onUpdateContent = (newContent) => {
    setProgress(null);
    setFileToDelete(null);
    if (newContent != null) {
      setContent(newContent);
    }
  }

  const deleteApplicationFile = (input, file) => {
    service.api.applicationContents.deleteFile(application.id, input.id, file.id, (response) => {
      if (response.result != null) {
        onUpdateContent(response.result);
      } else {
        onUpdateContent(null);
        alerter.showError(response.error);
      }
    });
  }

  const uploadApplicationFile = (input, file) => {

    var bin = {
        name: file.name,
        type: file.type,
        data: createByteArray(URL.createObjectURL(file))
    }

    service.api.applicationContents.createFile(application.id, input.id, bin, {
      onUpdateProgress: (progressValue) => { onUpdateProgress(progressValue) },
      result: (response) => {
        if (response.result != null) {
          onUpdateContent(response.result)
        } else {
          onUpdateContent(null);
          alerter.showError(response.error);
        }
      }
    });
  }

  const getApplicationFile = (application, input, file) => {
    setDownloadingB(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.applicationContents.getFile(application.id,input.id,file.id, {
      success: () =>  { 
        setDownloadingB(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingB(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingB(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });

  }

  const getAuxiliaryFile = (application, input, file) => {

    setDownloadingA(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.auxiliaryFiles.get(application.call.configurationId,input.id,file.id, {
      success: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });
  }

  return (
    <div className={style.row}>
      <Card style={{ marginTop: "15px", marginBottom: "15px"}}>
        <div>
          <div className={style.itemHeader} >
            <Typography className={style.titleInitial}>
              {input.name}
            </Typography>
          </div>
          <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
            <div className={style.itemContent}>
              <Typography style={{whiteSpace: "pre-line"}}>
                {input.description}
              </Typography>
            </div>
          </div>
          <div style={{ overflow: 'auto', paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
            <div className={style.itemContent}>
              { input.auxiliaryFiles.length !== 0 ? (
                <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                      <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                      Archivos<br/>auxiliares
                    </Typography>
                    { input.auxiliaryFiles.map((file) => (
                      <div>
                      { downloadingA[file.id] !== undefined ? 
                        (
                        <Stack alignItems="center" style={{width:"110px"}}>
                          <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingA[file.id]} />
                        </Stack>)
                        :(
                        <Stack alignItems="center" style={{width:"110px"}}>
                         <IconButton size="large" width="50px"  height="50px" onClick={ () => { getAuxiliaryFile(application,input,file); }} >
                            <DescriptionIcon fontSize="inherit" />
                          </IconButton>
                          <Tooltip title={file.bin.name}>
                            <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                          </Tooltip>
                        </Stack>)
                      }
                      </div>
                      ))
                    }
                  </Stack>
                ) : null
                }
            </div>
          </div>
          <div style={{ overflow: 'auto', paddingLeft: "12px", paddingRight: "12px", textAlign: "left", background: Constants.COLOR_GRAY_ULTRA_LIGHT}} >
            <div className={style.itemContent}>
                <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                  <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                    Archivos<br/>adjuntos
                  </Typography>
                  { content != null && content.files.map((file) => (
                      fileToDelete !== file.id ?                         
                        (
                          <div>
                          { downloadingB[file.id] !== undefined ? 
                            (
                            <Stack alignItems="center" style={{width:"110px"}}>
                              <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingB[file.id]} />
                            </Stack>)
                            :(
                            <Stack alignItems="center" style={{width:"110px"}}>
                            <IconButton size="large" width="50px"  height="50px" onClick={ () => { getApplicationFile(application,input,file); }} >
                              <FilePresentIcon fontSize="inherit" />
                            </IconButton>
                            <Tooltip title={file.bin.name}>
                                <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                            </Tooltip>
                            { application.canModify() ? 
                            (<Tooltip title="Borrar">
                              <IconButton size="small" onClick={ () => { onRemoveFile(file) }}>
                                <DeleteForeverIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>) : (null)
                            }
                            </Stack>)
                          }
                          </div>
                        ) :
                        (<Stack alignItems="center" style={{width:"110px"}}>
                          <CircularProgress style={{color:Constants.COLOR_PRIMARY}} />
                        </Stack>)
                    ))
                  }
                  { progress == null ? 
                    (<div>
                      { application.canModify() ? (
                        <Stack alignItems="center" style={{width:"110px"}}>
                          <IconButton onClick={onButtonClick} size="large" width="50px"  height="50px" >
                            <UploadFileIcon fontSize="inherit" />
                            <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={ (event) => onSelectFile(event,input) }/>
                          </IconButton>
                          <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center"}}>Subir archivo</span>
                        </Stack>) : (null)
                      }
                    </div>) : 
                    (<Stack alignItems="center" style={{width:"110px"}}>
                      <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={progress} />
                    </Stack>)
                  }
                </Stack>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
